export const environment = {
  production: false,
  apiUrl: 'https://bepos-boql.onrender.com',
};
